import { render } from "./jmedit.vue?vue&type=template&id=70955641&scoped=true"
import script from "./jmedit.vue?vue&type=script&lang=js"
export * from "./jmedit.vue?vue&type=script&lang=js"

import "./jmedit.vue?vue&type=style&index=0&id=70955641&lang=scss&scoped=true"
import "./jmedit.vue?vue&type=style&index=1&id=70955641&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70955641"]])

export default __exports__